import { render, staticRenderFns } from "./Moved.vue?vue&type=template&id=08cf5bd2"
import script from "./Moved.vue?vue&type=script&lang=js"
export * from "./Moved.vue?vue&type=script&lang=js"
import style0 from "./Moved.vue?vue&type=style&index=0&id=08cf5bd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports